module.exports = __webpack_public_path__ + "img/left_8.7fc6f971.png";